var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ss",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#078930",
    d: "M0 358.4h512V512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 153.6h512v204.8H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v153.6H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#da121a",
    d: "M0 179.2h512v153.6H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f47af",
    d: "m0 0 433 256L0 512z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcdd09",
    d: "M209 207.8 64.4 256l144.8 48.1-89.5-126v155.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs);
export default __webpack_public_path__ + "static/media/ss.ca92bc788ba791c96fb02e7cfd939cde.svg";
export { ForwardRef as ReactComponent };